import { api } from "./api";

export const apiReport = {
  exportLongPeriodReport: (filter, fileName = "Báo cáo kinh doanh dài hạn") =>
    api.postExcel("web/export/vehicles_long_period_report", {
      ...filter,
      fileName,
    }),

  exportOvertimeReport: (filter, fileName = "Báo cáo overtime") =>
    api.postExcel("web/export/overtime-report", { ...filter, fileName }),

  exportKmReport: (filter, fileName = "Báo cáo Km") =>
    api.postExcel("web/export/km-report", { ...filter, fileName }),

  exportFeeReport: (filter, fileName = "Báo cáo chi phí vé") =>
    api.postExcel("web/export/ticket_fee_report", { ...filter, fileName }),
};
